export const GET_ALLGENRES_LOADING = "GET_ALLGENRES_LOADING";
export const GET_ALLGENRES_SUCCESS = "GET_ALLGENRES_SUCCESS";
export const GET_ALLGENRES_FAILURE = "GET_ALLGENRES_FAILURE";

export const ADD_GENRE_LOADING = "ADD_GENRE_LOADING";
export const ADD_GENRE_SUCCESS = "ADD_GENRE_SUCCESS";
export const ADD_GENRE_FAILURE = "ADD_GENRE_FAILURE";

export const GET_GENRE_LOADING = "GET_GENRE_LOADING";
export const GET_GENRE_SUCCESS = "GET_GENRE_SUCCESS";
export const GET_GENRE_FAILURE = "GET_GENRE_FAILURE";
